// Coaching sessions as moments on the roadmap. Pure. A session is a dated
// coaching row in Finance Data (standing rows and one-offs, 36 Degrees' mode)
// or a dated block session (coaching engagements). Shown only when the
// roadmap's "Coaching sessions" switch is on: for a two-person engagement it
// fills the picture; for a thirty-seat cohort it would drown it, so the
// default is off unless Finance Config says `roadmapSessions: true`.
//   → [{ id, label, date, status: complete | missed | scheduled }]
export function sessionDots(finance, blockSessions, today) {
  const out = [];
  Object.entries(finance || {}).forEach(([ym, md]) => {
    (md.coaching || []).forEach(c => {
      if (!c.date) return;
      const past = c.date < today;
      out.push({ id: `s-${ym}-${c.id}`, label: c.label || c.id, date: c.date, status: past ? (c.happened ? "complete" : "missed") : "scheduled" });
    });
  });
  (blockSessions || []).forEach(s => {
    if (!s.date) return;
    out.push({ id: `b-${s.id}`, label: s.label || "Coaching session", date: s.date, status: s.status === "done" ? "complete" : s.status === "cancelled" ? "missed" : "scheduled" });
  });
  return out.sort((a, b) => a.date.localeCompare(b.date));
}

// The chart's status vocabulary: done filled, scheduled outlined, missed outlined in the off colour.
export const chartStatus = s => (s === "complete" ? "complete" : s === "missed" ? "missed" : "to-start");

export const upcomingSessions = (dots, today, n = 3) => dots.filter(d => d.date >= today).slice(0, n);
